import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

const urlOptions: QueryUrlOptions = {
  identifier: { type: 'phone-numbers' },
  op: 'query',
  resourcePath: 'phone-numbers',
};

export function sendPhoneVerificationRequest(phoneNumber?: string): RequestInfo {
  const url = buildBaseURL(urlOptions);
  const body: Record<string, string> = {};
  if (phoneNumber) {
    body['phone_number'] = phoneNumber;
  }
  return {
    url: `${url}/send-verification`,
    method: 'POST',
    body: JSON.stringify(body),
    cacheOptions: { [SkipCache]: true },
  };
}

export function verifyPhoneRequest(code: string, phoneNumber?: string): RequestInfo {
  const url = buildBaseURL(urlOptions);
  const body: Record<string, string> = { code };
  if (phoneNumber) {
    body['phone_number'] = phoneNumber;
  }
  return {
    url: `${url}/verify`,
    method: 'POST',
    body: JSON.stringify(body),
    cacheOptions: { [SkipCache]: true },
  };
}
